module.exports = __webpack_public_path__ + "img/MapThumb_DuelingIslands.334d54c1.webp";